import { OpeningHours, OpeningHoursType, WeekDay } from '../types';

export const fakeOpeningHoursFactory = {
  createOpeningHours: (
    openingHours: Partial<OpeningHours> = {},
  ): OpeningHours => ({
    openingHoursType: OpeningHoursType.CUSTOM,
    openingHoursPerWeekDay: [
      {
        weekday: WeekDay.MONDAY,
        from: '06:00:00',
        to: '22:00:00',
      },
      {
        weekday: WeekDay.TUESDAY,
        from: '06:00:00',
        to: '22:00:00',
      },
      {
        weekday: WeekDay.WEDNESDAY,
        from: '06:00:00',
        to: '22:00:00',
      },
      {
        weekday: WeekDay.THURSDAY,
        from: '06:00:00',
        to: '22:00:00',
      },
      {
        weekday: WeekDay.FRIDAY,
        from: '06:00:00',
        to: '22:00:00',
      },
      {
        weekday: WeekDay.SATURDAY,
        from: '06:00:00',
        to: '22:00:00',
      },
      {
        weekday: WeekDay.SUNDAY,
        from: '06:00:00',
        to: '22:00:00',
      },
    ],
    timezone: 'Europe/Berlin',
    ...openingHours,
  }),
};

export const fakeOpeningHours: OpeningHours =
  fakeOpeningHoursFactory.createOpeningHours();
